import React, { useState, useEffect } from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles(() => ({
  pendingChip: {
    height: 18,
    fontSize: "0.65rem",
    fontWeight: 700,
    borderRadius: 4,
    cursor: "default",
    marginLeft: 4,
  },
  pendingColor: {
    backgroundColor: "#f59e0b",
    color: "#fff",
  },
  overdueColor: {
    backgroundColor: "#ef4444",
    color: "#fff",
  },
  noDateColor: {
    backgroundColor: "#6b7280",
    color: "#fff",
  },
}));

// Formatea el tiempo restante de forma legible
const formatCountdown = (dueDate) => {
  if (!dueDate) return null;
  const diff = new Date(dueDate) - Date.now();
  if (diff <= 0) return null;
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
};

const TicketPendingBadge = ({ pending }) => {
  const classes = useStyles();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(interval);
  }, []);

  if (!pending) return null;

  const { status, dueDate } = pending;

  if (status === "resolved") return null;

  if (status === "overdue") {
    return (
      <Tooltip title="Pendiente vencido" placement="top">
        <Chip
          icon={<WarningIcon style={{ fontSize: 11, color: "#fff" }} />}
          label="Vencido"
          size="small"
          className={`${classes.pendingChip} ${classes.overdueColor}`}
        />
      </Tooltip>
    );
  }

  // status === "pending"
  if (!dueDate) {
    return (
      <Tooltip title="Pendiente sin fecha" placement="top">
        <Chip
          icon={<AccessTimeIcon style={{ fontSize: 11, color: "#fff" }} />}
          label="Pendiente"
          size="small"
          className={`${classes.pendingChip} ${classes.noDateColor}`}
        />
      </Tooltip>
    );
  }

  const countdown = formatCountdown(dueDate);
  const label = countdown ? `⏰ ${countdown}` : "Pendiente";

  return (
    <Tooltip
      title={`Pendiente hasta ${new Date(dueDate).toLocaleString("es-AR")}`}
      placement="top"
    >
      <Chip
        label={label}
        size="small"
        className={`${classes.pendingChip} ${classes.pendingColor}`}
      />
    </Tooltip>
  );
};

export default TicketPendingBadge;
